module.exports = __webpack_public_path__ + "img/lbl01.f7077957.png";